module.exports = __webpack_public_path__ + "static/media/subscribeDiscount2.f7dbd68d.svg";